/**
 * Returns the logo for the given MLS
 * @param mlsId
 * @returns {string | null}
 */
export const MlsWatermarkLogoHelper = {
  getMlsLogo: (mlsId?: string): string | null => {
    if (!mlsId) {
      return null;
    }
    switch (mlsId.toLowerCase()) {
      case 'metrolist':
        return '2023-04-1681502987434-84915.png';
      default:
        return null;
    }
  },
};
